export var resources = {
	"en": {
		translation: {}
	},
	"ja": {
		translation: {
			"Select" : "選択",
			"Text" : "文字",
			"Unimplemented" : "未実装",
			"Done" : '済',
			"Save": "保存",
			"List": "一覧",
			"Search": "検索",
			"Clear": "クリア",
			"Redraw": "再描画",
			"Undo": "Undo",
			"Overwrite": "追加保存",
			"Select a figure to overwrite": "上書きする図を選択してください",
			"<- OK to overwrite?": "に追加書き込みしますか？",
			"14px 'Helvetica'": "14px 'ＭＳ Ｐゴシック'",
			"16px 'Helvetica'": "16px 'ＭＳ Ｐゴシック'",
			"20px 'Helvetica'": "20px 'ＭＳ Ｐゴシック'",
			"String": "文字列",
			"Size": "サイズ",
			"Input image size in pixels": "画像サイズを入力してください(ピクセル)",
		},
		font : {
			"orn" : "10px MS Gothic",
			"Potato" : "10px MS Gothic"
		}
	}
}
